import styled from '@emotion/styled';
import { trackEvent } from 'src/lib/googleAnalytics';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { IconChevronLeft } from '../../BasicComponents/Icons';

export const CloseSidebarButton = ({ onClick }: { onClick: () => void }) => (
  <CloseIconWrapper
    {...onClickGenerator(() => {
      trackEvent('starter_list', { action: 'close' });
      onClick();
    })}
  />
);

const CloseIconWrapper = styled(IconChevronLeft)`
  display: none;
  position: absolute;
  top: 0;
  left: -40px;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;

  @media screen and (max-width: 750px) {
    display: block;
  }
`;
